import { forwardRef } from 'react';
import { cn } from '../../lib/cn';

const SIZES = {
  sm: { track: 'h-4 w-7', knob: 'h-3 w-3', translate: 12 },
  md: { track: 'h-5 w-9', knob: 'h-4 w-4', translate: 16 },
};

export const Switch = forwardRef(function Switch(
  {
    className,
    checked = false,
    onChange,
    disabled,
    size = 'md',
    name,
    id,
    ...props
  },
  ref
) {
  const cfg = SIZES[size];
  return (
    <button
      ref={ref}
      type="button"
      role="switch"
      aria-checked={checked}
      id={id}
      name={name}
      disabled={disabled}
      onClick={() => !disabled && onChange?.(!checked)}
      className={cn(
        'relative inline-flex shrink-0 cursor-pointer items-center rounded-full transition-all duration-300',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--dash-primary)]/40',
        disabled && 'cursor-not-allowed opacity-50',
        cfg.track,
        className
      )}
      style={{
        background: checked
          ? 'linear-gradient(135deg, #ad34fe 0%, #7b1fd4 100%)'
          : 'var(--dash-surface-hover)',
        border: checked
          ? '1px solid rgba(173,52,254,0.5)'
          : '1px solid var(--dash-border-strong)',
        boxShadow: checked ? '0 0 14px rgba(173,52,254,0.35)' : 'none',
      }}
      {...props}
    >
      <span
        className={cn(
          'pointer-events-none inline-block transform rounded-full bg-white shadow-md ring-0 transition-transform duration-300',
          cfg.knob
        )}
        style={{
          transform: `translateX(${checked ? cfg.translate : 2}px)`,
        }}
      />
    </button>
  );
});
